export default __webpack_public_path__ + "static/media/arrow-right-disable.681efd76.svg";